module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-select",
    class: {
      solo: _vm.solo
    }
  }, [_c('div', {
    staticClass: "selected",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.display()
      }
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.displayValue(_vm.select)) + "\n\t\t"), _c('span', {
    staticClass: "icon-arrow-full-down",
    class: {
      deploy: _vm.show
    }
  })]), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "items"
  }, _vm._l((_vm.items), function(item, eq) {
    return _c('div', {
      key: eq,
      staticClass: "item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setSelect(eq)
        }
      }
    }, [_vm._v("\n\t\t\t" + _vm._s(_vm.displayValue(item)) + "\n\t\t")])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b5ce3f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/Form/CustomSelect.vue
// module id = 1154
// module chunks = 0